import { useMemo } from 'react';
import { getDocumentFields, getImage, getItemsByType } from 'utils/helper';
import LinkWrapper from 'UI/components/LinkWrapper';
import SectionTitle from 'UI/components/SectionTitle';
import Link from 'next/link';
import cn from 'classnames';
import Illustration from 'UI/components/Illustration';
import styles from './styles.module.scss';

const Works = ({ section, type }) => {
  const {
    title,
    description,
    contentModules,
  } = useMemo(() => getDocumentFields(
    section,
    [
      'title',
      'description',
      'contentModules',
    ],
  ), [section]);

  const [projectsData] = getItemsByType(
    contentModules,
    'block',
    [
      'contentModules',
    ],
  );

  const [link] = getItemsByType(
    contentModules,
    'link',
    ['buttonTitle', 'url'],
  );

  const projects = useMemo(() => projectsData?.contentModules.map((project) => {
    const {
      title: projectTitle,
      description: projectDescription,
      images,
      contentList,
    } = getDocumentFields(project, [
      'title',
      'description',
      'images',
      'contentList',
    ]);
    const { url: video } = getImage(images?.[0]);

    return {
      projectTitle,
      projectDescription,
      video,
      path: contentList?.[0] || '',
    };
  }), [projectsData]);

  return (
    <section className={cn(styles.section, styles[type])}>
      <SectionTitle
        title={title}
        description={description}
        className={styles.titleStyle}
      />

      <div className={styles.contentWrapper}>
        {(projects || []).map(({
          path,
          video,
          ref,
          projectTitle,
          projectDescription,
        }) => {
          const isVideo = video.includes('videos.');

          return (
            <Link
              key={path}
              href={path}
            >
              {/* eslint-disable-next-line react/jsx-no-target-blank,jsx-a11y/anchor-is-valid,jsx-a11y/no-static-element-interactions */}
              <a className={styles.projectWrapper}>
                {isVideo ? (
                  <video
                    ref={ref}
                    muted
                    loop
                    autoPlay
                    playsInline
                    className={styles.video}
                  >
                    <source
                      src={video}
                      type="video/mp4"
                    />
                  </video>
                ) : (
                  <Illustration
                    src={video}
                    alt={projectTitle}
                    className={styles.video}
                  />
                )}

                <div className={styles.descriptionContainer}>
                  <h4 className={styles.title}>{projectTitle}</h4>
                  <p className={styles.description}>{projectDescription}</p>
                </div>
              </a>
            </Link>
          );
        })}
      </div>

      {link && (
        <LinkWrapper
          path={link.url}
          className={styles.link}
        >
          {link.buttonTitle}
        </LinkWrapper>
      )}
    </section>
  );
};

export default Works;
